import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=fba771d8&"
import script from "./AccountDetails.vue?vue&type=script&lang=ts&"
export * from "./AccountDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports